import { NavLink } from "react-router-dom";

const icons = {
  "/": "fa-home",
  "/time-clock": "fa-clock",
  "/leave": "fa-calendar-check",
  "/claims": "fa-receipt",
  "/edocs": "fa-file-alt",
  "/communications": "fa-comments",
  "/events": "fa-calendar-day",
};

const Item = ({ item, t }) => {
  const label = item.title === "Home"
      ? t("Home")
      : item.title === "Leave"
      ? t("Leave")
      : item.title === "Claims"
      ? t("Claims") 
      : item.title === "Timeclock"
      ? t("Timeclock") 
      : item.title;

  return (
    <NavLink
      to={item.link}
      exact
      activeClassName="active-menu-item"
      className="sidebar-nav-item"
    >
      <i className={`fas ${icons[item.link] || "fa-circle"}`} aria-hidden="true" />
      <span>{label}</span>
    </NavLink>
  );
};

export default Item;
